if (!( (window).__divanoContactClick)) {
   (window).__divanoContactClick = true;
  const record = (event) => {
    if (event.type === 'auxclick' && event.button !== 1) return;
    const target =  (event.target instanceof Element ? event.target : null);
    const link = target && target.closest('[data-divano-contact]');
    if (!(link instanceof HTMLElement)) return;
    try {
       (window).Shopify?.analytics?.publish?.('divano_contact_click', {
        channel: link.dataset.divanoContact,
        surface: link.dataset.divanoContactSurface,
        product_id: Number(link.dataset.divanoContactProduct) || null,
      });
    } catch (error) {
    }
  };
  document.addEventListener('click', record);
  document.addEventListener('auxclick', record);
}
